import { createElementBlock as l, openBlock as a, normalizeClass as m, createElementVNode as o, Fragment as u, renderList as p, createBlock as i, createCommentVNode as g, withCtx as k, createTextVNode as _, toDisplayString as c } from "vue";
import b from "../../atoms/anchor-element/anchor-element.vue.js";
import f from "../../atoms/icon-core/icon-core.vue.js";
import { themeProp as y } from "../../composables/useTheme.js";
/* empty css                 */
import h from "../../_virtual/_plugin-vue_export-helper.js";
const x = { class: "ds-display-flex ds-align-items-center ds-scrollbar-hidden ds-overflow-x-auto gap-2" }, v = {
  key: 1,
  "aria-current": "page",
  class: "ds-breadcrumbs__item ds-breadcrumbs__item--current",
  "data-j-current-page": ""
}, w = /* @__PURE__ */ Object.assign({
  name: "DsBreadcrumbs"
}, {
  __name: "breadcrumbs",
  props: {
    ...y,
    crumbs: {
      type: Array,
      required: !0,
      validator: (r) => r.every((t, n, e) => n === e.length - 1 ? "title" in t : ["title", "url"].every((s) => s in t))
    },
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) }
  },
  emits: ["link-clicked"],
  setup(r) {
    return (t, n) => (a(), l("nav", {
      "aria-label": "Breadcrumb",
      class: m(["ds-breadcrumbs__wrapper", `ds-breadcrumbs__wrapper--${t.theme}`])
    }, [
      o("ol", x, [
        (a(!0), l(u, null, p(r.crumbs, (e, s) => (a(), l("li", {
          key: s,
          class: "ds-display-flex ds-align-items-center ds-text-small gap-2"
        }, [
          s < r.crumbs.length - 1 ? (a(), i(b, {
            key: 0,
            url: e.url,
            "tracking-data": { "component-name": t.$options.name, text: e.title, url: e.url, ...r.trackingData },
            class: "ds-breadcrumbs__item",
            nuxt: e.nuxt ?? !0,
            "data-j-link": "",
            onLinkClicked: n[0] || (n[0] = (d) => t.$emit("link-clicked", d))
          }, {
            default: k(() => [
              _(c(e.title), 1)
            ]),
            _: 2
          }, 1032, ["url", "tracking-data", "nuxt"])) : (a(), l("span", v, c(e.title), 1)),
          s < r.crumbs.length - 1 ? (a(), i(f, {
            key: 2,
            class: "icon-arrow",
            name: "chevron-right-extra-small",
            category: "arrows",
            "aria-hidden": "true"
          })) : g("", !0)
        ]))), 128))
      ])
    ], 2));
  }
}), V = /* @__PURE__ */ h(w, [["__scopeId", "data-v-35831108"]]);
export {
  V as default
};
